module.exports = __webpack_public_path__ + "static/media/doctor_female.22c4d1cc.png";